import {Layout} from '../../components/LayoutComponents';

export const HelpPage: React.FC = () => {
  return <Layout pageTitle='Hilfe' paddingBottom></Layout>;
};
